import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {getCalculateDistractById, getsaleById, getSaleMedicalRecordsById} from './core/_request'
import {Outlet, useNavigate, useParams} from 'react-router-dom'
import {BillingProvider, useBillingContext} from './core/billingProvider'
import {ContractProvider, useContractContext} from './core/ContractProvider'
import {ContractListModal} from './components/contracts-list-modal/ContractListModal'
import {ContractList} from './components/ContractList'
import {BillingList} from './components/BillingList'
import {ItemSaleList} from './components/ItemSaleList'
import {useEffect, useMemo, useState} from 'react'
import {CalculateDistract, ISaleResponse} from '../../coreGlobal/models/sale'
import {ResponsibleDetail} from './components/ResponsibleDetail'
import {ListSalesMedicalRecords} from './components/ListSalesMedicalRecords'
import {ListSalesHistorySchedules} from './components/ListSalesHistorySchedules'
import Swal from 'sweetalert2'
import {formatDateTime} from '../../utils/dayJs/format'
import {ListSalesStatus} from './components/ListSaleStatus'
import {RecurrentPaymentProvider} from './components/modalRecurrentPayment/core/recurrentPaymentProvider'
import {PageOverlayer} from '../../components/PageOverlayer'
import {PaymentConfigProvider} from '../../components/PaymentConfig/core/PaymentConfigProvider'
import {DropdownSale} from './components/DropdownSale'
import {DistractList} from '../../components/Distract/DistractList'
import {IconIsActive} from '../../components/IconIsActive'
import useAuthorization from '../../hooks/useAuthorization'
import {getReasons} from '../clients/components/FranchiseTransfer/core/_request'
import {ISelect} from '../../coreGlobal/models/default'
import {useFranchiseTransferCart} from '../clients/components/FranchiseTransfer/core/FranchiseTransferProvider'
import {LoadingSpinner} from '../../utils/loading/loadingSpinner'

import Select from 'react-select'
import ReasonCancel from '../clients/components/CancelContract/ReasonCancel'

const machineBreadcrumbs: Array<PageLink> = [
  {
    title: 'Vendas',
    path: '/sales',
    isSeparator: false,
    isActive: false,
  },
]

const ListSalesHistoryMedicalRecord = ({data}) => {
  const [dataSale, setDataSale] = useState()

  useEffect(() => {
    const init = async () => {
      try {
        const salesHistorySchedules = await getSaleMedicalRecordsById(Number(data))
        setDataSale(salesHistorySchedules)
      } catch (error: any) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message,
          timer: 2000,
        })
      }
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return <ListSalesHistorySchedules salesHistorySchedules={dataSale} />
}

export const SaleShowPage = () => {
  let {id} = useParams()
  const {contractView, setContractView} = useContractContext()
  const [status, setStatus] = useState('')
  const [loadingPage, setLoadingPage] = useState(false)
  const {setBillingData} = useBillingContext()
  const [saleData, setSaleData] = useState<ISaleResponse>()

  const [loading, setLoading] = useState(false)
  const [option, setOption] = useState<ISelect[]>([])

  const STATUS_TO_HIDE_CANCELLATION = [4, 5, 7, 8, 11, 18]
  const [calculateDistractItems, setCalculateDistractItems] = useState<CalculateDistract>()
  const {transferStatus} = useFranchiseTransferCart()

  const isAuthorizedToDistractsCreate = useAuthorization('distracts.create')
  const isAuthorizedToDistractsCancelProductContract = useAuthorization(
    'distracts.cancel_product_contract'
  )
  const [cancellationType, setCancellationType] = useState<ISelect | null>(null)

  const onlyProductCategoryThree = (items) => {
    return items?.length > 0 && items.every((item) => item.product?.category_id === 3)
  }

  const isAuthorizedToDistractsViewIncorrectContract = useAuthorization(
    'distracts.view_incorrect_contract'
  )
  const isAuthorizedToDistractsViewCustomerWithdrawal = useAuthorization(
    'distracts.view_customer_withdrawal'
  )
  const getCalculateDistract = async (saleId: number) => {
    try {
      setLoading(true)
      const data = await getCalculateDistractById({id: saleId})
      setCalculateDistractItems(data)

      const reasonsData = await getReasons()

      const mappedOptions = reasonsData.map((item) => ({
        value: String(item.id),
        label: item.name,
        observation_required: item.observation_required,
      }))
      setOption(mappedOptions)
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Ops! Revise seu formulário e tente novamente!',
        html: error,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary',
        },
      })
    } finally {
      setLoading(false)
    }
  }

  const cancellationTypeOption = useMemo(
    () => [
      {value: '1', label: 'Cancelar'},

      ...(isAuthorizedToDistractsViewIncorrectContract ||
      isAuthorizedToDistractsViewCustomerWithdrawal
        ? [{value: '2', label: 'Anular'}]
        : []),
    ],
    [isAuthorizedToDistractsViewIncorrectContract, isAuthorizedToDistractsViewCustomerWithdrawal]
  )

  const filteredOptions = useMemo(() => {
    if (cancellationType === null) {
      return []
    }
    // Cancelar
    if (cancellationType?.value === '1') {
      return option.filter((item) => !['12', '13'].includes(item.value))
    }

    // Anular
    if (cancellationType?.value === '2') {
      return option.filter((item) => ['12', '13'].includes(item.value))
    }

    return option
  }, [option, cancellationType])

  const navigate = useNavigate()
  useEffect(() => {
    const init = async () => {
      setLoadingPage(true)
      try {
        const data = await getsaleById(String(id))
        setSaleData(data)
        setBillingData(data.billings)
        setLoadingPage(false)
      } catch (error: any) {
        setLoadingPage(false)
        Swal.fire({
          title: 'Erro',
          text: error.response.data.message,
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/sales/list')
          }
        })
      }
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (saleData) {
      switch (saleData.status) {
        case 'Pendente':
          setStatus('btn btn-light-primary')
          break
        case 'Pago':
          setStatus('btn btn-light-success')
          break
        case 'Cancelado':
          setStatus('btn btn-light-danger')
          break
        case 'Reprovada':
          setStatus('btn btn-light-danger')
          break
        case 'Em Análise':
          setStatus('btn btn-light-warning')
          break
        default:
          setStatus('btn btn-light-secondary')
      }
    }
  }, [saleData])

  const get_badge_class = () => {
    let badgeClass = ''
    switch (saleData?.client?.lastClientHistory?.status.name) {
      case 'Ativo':
        badgeClass = 'success'
        break
      case 'Restrito':
        badgeClass = 'warning'
        break
      default:
        badgeClass = 'danger'
        break
    }
    return badgeClass
  }

  function getAvatarImg(person) {
    if (person?.hideAvatar) {
      return 'avatar-neutro.svg'
    }
    switch (person?.gender) {
      case 'F':
        return 'avatar-feminino.svg'
      case 'M':
        return 'avatar-masculino.svg'
      default:
        return 'avatar-neutro.svg'
    }
  }
  return (
    <>
      {loadingPage ? (
        <PageOverlayer />
      ) : (
        <>
          <Outlet />
          <div className='card mb-5 mb-xl-10'>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img
                      src={toAbsoluteUrl(
                        `/media/avatars/${getAvatarImg(saleData?.client?.physicalPerson)}`
                      )}
                      alt='Metronic'
                    />
                    <div
                      className={`position-absolute translate-middle bottom-0 start-100 mb-6 bg-${get_badge_class()} rounded-circle border border-4 border-white h-20px w-20px`}
                    ></div>
                  </div>
                </div>
                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        {saleData?.client?.activeAlert && (
                          <IconIsActive text={saleData?.client?.alerts?.[0]?.observation} />
                        )}
                        <a
                          className='text-gray-800 text-hover-danger fs-2 fw-bolder me-1'
                          href={`/people/list/${saleData?.client?.id}`}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {` ${saleData?.client?.id} - ${saleData?.client?.name} - VENDA: ${saleData?.id}`}
                        </a>
                      </div>
                      <div className='fs-4 fw-bolder me-1'>
                        <strong>
                          {saleData?.contractAt
                            ? formatDateTime(saleData.contractAt)
                            : formatDateTime(String(saleData?.createdAt))}
                        </strong>
                      </div>
                    </div>
                    <div className='d-flex '>
                      <h1 className='me-1'>
                        <a className={`${status}`}>Status: {saleData?.status}</a>
                      </h1>
                      {saleData && (
                        <DropdownSale
                          saleData={saleData}
                          canCanSale={
                            saleData.billings.some((billing) => billing.status === 'Pendente') ||
                            false
                          }
                          canChangePayment={
                            saleData.billings.some((billing) => billing.status === 'Pendente') ||
                            false
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <button
                      className='nav-link active'
                      id='pills-items-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-items'
                      type='button'
                      role='tab'
                      aria-controls='pills-items'
                      aria-selected='true'
                    >
                      Itens da Venda
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-charge-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-charge'
                      type='button'
                      role='tab'
                      aria-controls='pills-charge'
                      aria-selected='true'
                    >
                      Historico Cobrança
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-contact-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-tabcontract'
                      type='button'
                      role='tab'
                      aria-controls='pills-tabcontract'
                      aria-selected='true'
                    >
                      Contratos
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-medical-records-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-tab-medical-records'
                      type='button'
                      role='tab'
                      aria-controls='pills-tab-medical-records'
                      aria-selected='true'
                    >
                      Prontuário
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-history-schedules-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-history-schedules'
                      type='button'
                      role='tab'
                      aria-controls='pills-history-schedules'
                      aria-selected='true'
                    >
                      Histórico de agendamento
                    </button>
                  </li>
                  {saleData?.distracts && saleData.distracts.length > 0 && (
                    <li className='nav-item'>
                      <button
                        className='nav-link'
                        id='pills-distract-tab'
                        data-bs-toggle='pill'
                        data-bs-target='#pills-distract'
                        type='button'
                        role='tab'
                        aria-controls='pills-distract'
                        aria-selected='true'
                      >
                        Distrato
                      </button>
                    </li>
                  )}
                  {saleData?.responsible && (
                    <li className='nav-item'>
                      <button
                        className='nav-link'
                        id='pills-responsible-tab'
                        data-bs-toggle='pill'
                        data-bs-target='#pills-responsible'
                        type='button'
                        role='tab'
                        aria-controls='pills-responsible'
                        aria-selected='true'
                      >
                        Responsável
                      </button>
                    </li>
                  )}
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-salesHistory-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-salesHistory'
                      type='button'
                      role='tab'
                      aria-controls='pills-salesHistory'
                      aria-selected='true'
                    >
                      Histórico de Status
                    </button>
                  </li>
                  {isAuthorizedToDistractsCreate &&
                    saleData?.statusId !== undefined &&
                    STATUS_TO_HIDE_CANCELLATION.includes(saleData.statusId) &&
                    !transferStatus &&
                    (!onlyProductCategoryThree(saleData.items) ||
                      isAuthorizedToDistractsCancelProductContract) && (
                      <li className='nav-item'>
                        <button
                          className='nav-link'
                          id='pills-cancel-contract-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-cancel-contract'
                          type='button'
                          role='tab'
                          aria-controls='pills-cancel-contract'
                          aria-selected='true'
                          onClick={() => {
                            if (saleData?.id) {
                              getCalculateDistract(saleData.id)
                            }
                          }}
                        >
                          Cancelar Contrato
                        </button>
                      </li>
                    )}
                </ul>
              </div>
            </div>
          </div>
          <PageTitle breadcrumbs={machineBreadcrumbs}>Detalhamento da Venda</PageTitle>
          <div className='tab-content' id='pills-tabContent'>
            <div
              className='tab-pane fade show active p-4 pt-0 pt-md-4'
              id='pills-items'
              role='tabpanel'
              aria-labelledby='pills-checklist-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <ItemSaleList
                  itemSaleData={saleData?.items}
                  saleId={saleData?.id ? saleData.id : 0}
                />
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-charge'
              role='tabpanel'
              aria-labelledby='pills-checklist-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <BillingList saleStatus={saleData?.status} />
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-tabcontract'
              role='tabpanel'
              aria-labelledby='pills-checklist-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <ContractList saleId={id} />
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-tab-medical-records'
              role='tabpanel'
              aria-labelledby='pills-checklist-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <ListSalesMedicalRecords saleId={Number(id)} />
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-history-schedules'
              role='tabpanel'
              aria-labelledby='pills-checklist-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <ListSalesHistoryMedicalRecord data={Number(id)} />
              </div>
            </div>
            {saleData?.distracts && (
              <div
                className='tab-pane fade p-4 pt-0 pt-md-4'
                id='pills-distract'
                role='tabpanel'
                aria-labelledby='pills-checklist-tab'
              >
                <div className='card mb-5 mb-xl-10'>
                  <DistractList data={saleData.distracts} />
                </div>
              </div>
            )}
            {saleData?.responsible && (
              <div
                className='tab-pane fade p-4 pt-0 pt-md-4'
                id='pills-responsible'
                role='tabpanel'
                aria-labelledby='pills-checklist-tab'
              >
                <div className='card mb-5 mb-xl-10'>
                  <ResponsibleDetail responsibleData={saleData?.responsible} />
                </div>
              </div>
            )}
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-salesHistory'
              role='tabpanel'
              aria-labelledby='pills-salesHistory'
            >
              <div className='card mb-5 mb-xl-10'>
                <ListSalesStatus history={saleData?.history} />
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-cancel-contract'
              role='tabpanel'
              aria-labelledby='pills-cancel-contract-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-body py-3'>
                  <>
                    {loading && (
                      <LoadingSpinner
                        title='Carregando'
                        style={{
                          width: '2rem',
                          height: '2rem',
                          colorSpinner: '#f1416c',
                          colorText: '#f1416c',
                        }}
                      />
                    )}
                    {!loading &&
                      saleData?.statusId !== undefined &&
                      STATUS_TO_HIDE_CANCELLATION.includes(saleData.statusId) &&
                      !transferStatus && (
                        <div className='row mb-6'>
                          <div className='column col-lg-4'>
                            <label className='col-lg-12 col-form-label fw-bold fs-6'>
                              <span>Tipo de cancelamento?</span>
                            </label>
                            <div className='col-lg-10 fv-row'>
                              <Select
                                id={`cancellationType`}
                                className='react-select-styled react-select-solid '
                                classNamePrefix='react-select'
                                onChange={(option) => {
                                  setCancellationType(option!)
                                }}
                                options={cancellationTypeOption}
                                value={cancellationType}
                                placeholder='Selecione'
                              />
                            </div>
                          </div>
                          {cancellationType && (
                            <ReasonCancel
                              saleId={saleData?.id}
                              items={calculateDistractItems!}
                              option={filteredOptions}
                              cancellationType={cancellationType}
                            />
                          )}
                        </div>
                      )}
                  </>
                </div>
              </div>
            </div>
          </div>
          {contractView && <ContractListModal saleId={id} />}
        </>
      )}
    </>
  )
}

export const SalesViewPage = () => {
  return (
    <>
      <ContractProvider>
        <BillingProvider>
          <RecurrentPaymentProvider>
            <PaymentConfigProvider>
              <SaleShowPage />
            </PaymentConfigProvider>
          </RecurrentPaymentProvider>
        </BillingProvider>
      </ContractProvider>
    </>
  )
}
